import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=1dad9618&scoped=true&"
import script from "./HelpCenter.vue?vue&type=script&lang=js&"
export * from "./HelpCenter.vue?vue&type=script&lang=js&"
import style0 from "./HelpCenter.vue?vue&type=style&index=0&id=1dad9618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dad9618",
  null
  
)

export default component.exports